// QueueStatusChip.jsx
import React from "react";
import { Chip } from "@mui/material";
import { MdHourglassTop, MdCheckCircle, MdPending } from "react-icons/md";

const QueueStatusChip = ({ status }) => {
  if (!status) return null;

  const stat = status.toLowerCase();

  const statusConfig = {
    processing: {
      label: "Processing",
      icon: <MdHourglassTop size={18} />,
      bgColor: "#ed6c02", // MUI warning orange
    },
    completed: {
      label: "Completed",
      icon: <MdCheckCircle size={18} />,
      bgColor: "#2e7d32", // success green
    },
    scheduled: {
      label: "Scheduled",
      icon: <MdPending size={18} />,
      bgColor: "#0288d1", // info blue
    },
    default: {
      label: status,
      icon: <MdPending size={18} />,
      bgColor: "#616161", // grey fallback
    },
  };

  const { label, icon, bgColor } = statusConfig[stat] || statusConfig.default;

  return (
    <Chip
      icon={icon}
      label={label}
      size="small"
      sx={{
        backgroundColor: bgColor,
        color: "white",
        "& .MuiChip-icon": { color: "white" },
        "&:hover": { opacity: 0.9 },
      }}
    />
  );
};

export default QueueStatusChip;
